export default {
  // createOrganization
  START_CREATE_ORG: 'START_CREATE_ORG',
  CREATE_ORG_SUCCESS: 'CREATE_ORG_SUCCESS',
  CREATE_ORG_FAILED: 'CREATE_ORG_FAILED',
  // getOrganizationList
  START_GET_ORG_LIST: 'START_GET_ORG_LIST',
  GET_ORG_LIST_SUCCESS: 'GET_ORG_LIST_SUCCESS',
  GET_ORG_LIST_FAILED: 'GET_ORG_LIST_FAILED',
  // getOrganizationById
  START_GET_ORG_BY_ID: 'START_GET_ORG_BY_ID',
  GET_ORG_BY_ID_SUCCESS: 'GET_ORG_BY_ID_SUCCESS',
  GET_ORG_BY_ID_FAILED: 'GET_ORG_BY_ID_FAILED',
  // updateOrganization
  START_UPDATE_ORG: "START_UPDATE_ORG",
  UPDATE_ORG_SUCCESS: "UPDATE_ORG_SUCCESS",
  UPDATE_ORG_FAILED: "UPDATE_ORG_FAILED"
};
